import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/table/table.component.js'

const tagName = 'dap-ds-table'

/**
 * Data table component.
 * @element dap-ds-table
 * @title - Table
 *
 * @slot - The default slot. Accepts `dap-ds-table-row` elements.
 *
 * @cssprop --dds-table-border-width - Width of the table border. Default: var(--dds-border-width-base, 1px)
 * @cssprop --dds-table-border-color - Color of the table border. Default: var(--dds-border-neutral-subtle)
 * @cssprop --dds-table-border-radius - Border radius of the table. Default: var(--dds-radius-small, 4px)
 * @cssprop --dds-table-row-divider-color - Color of the divider between rows in mobile view. Default: var(--dds-border-neutral-subtle)
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTable',
})

export default reactWrapper
